export default __webpack_public_path__ + "static/dge_small-image_3-88956a6b39d4efcb5dc7b23f2436b151.webp";